import React from 'react';
import { observer } from 'mobx-react';

import { SimpleProductCard } from '../../../common/simple-product-card';
import { Separator } from '../separator';
import { ProductStore } from '../stores/ProductStore';
import { RelatedProductsStore } from '../stores/RelatedProductsStore';
import styles from './OtherProductsSection.css';

const OtherProductsSection = observer(class OtherProductsSection extends React.Component {
  componentDidMount() {
    RelatedProductsStore.fetchRelatedAndAccessories(ProductStore.product.id);
  }

  static renderProductList(products) {
    return products.map(product => (
      <SimpleProductCard
        className={styles.productCard}
        key={product.id}
        product={product}
      />
    ));
  }

  render() {
    return (
      <div>
        {
          RelatedProductsStore.relatedProducts !== null &&
          RelatedProductsStore.relatedProducts.length !== 0 &&
          <div>
            <h2 className={styles.title}>
              Productos relacionados
            </h2>
            <div className={styles.cardContainer}>
              {OtherProductsSection.renderProductList(RelatedProductsStore.relatedProducts)}
            </div>
            <Separator />
          </div>
        }
        {
          RelatedProductsStore.accessories !== null &&
          RelatedProductsStore.accessories.length !== 0 &&
          <div>
            <h2 className={styles.title}>
              Accesorios para este producto
            </h2>
            <div className={styles.cardContainer}>
              {OtherProductsSection.renderProductList(RelatedProductsStore.accessories)}
            </div>
            <Separator />
          </div>
        }
      </div>
    );
  }
});

export { OtherProductsSection };



// WEBPACK FOOTER //
// ./src/pages/product-detail/other-products-section/OtherProductsSection.jsx